module.exports = __webpack_public_path__ + "static/media/tenant_mylight_in.7b9f5e5b.svg";